import { useCallback, useEffect, useState } from "react";
import FormField from "../form-field";

const defaultForm = {
  school: "",
  degree: "",
  course: "",
  qualificationClass: "",
  startYear: "",
  endYear: "",
};

const degreeOptions = [
  { value: "", label: "Select degree" },
  { value: "BSc", label: "BSc" },
  { value: "B. Tech", label: "B. Tech" },
  { value: "HND", label: "HND" },
  { value: "MSC", label: "MSC" },
  { value: "ND", label: "ND" },
  { value: "PhD", label: "PhD" },
];

const Education = ({ data, onDataChange, errors = [], showErrors = false }) => {
  const [educationItems, setEducationItems] = useState(
    Array.isArray(data) && data.length > 0 ? data : [{ ...defaultForm }],
  );

  useEffect(() => {
    onDataChange?.(educationItems);
  }, [educationItems, onDataChange]);

  const handleChange = useCallback((index, e) => {
    const { name, value } = e.target;
    setEducationItems((prev) =>
      prev.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [name]: value } : item,
      ),
    );
  }, []);

  const addEducation = () => {
    setEducationItems((prev) => [...prev, { ...defaultForm }]);
  };

  const removeEducation = (index) => {
    setEducationItems((prev) => {
      if (prev.length === 1) {
        return prev;
      }

      return prev.filter((_, itemIndex) => itemIndex !== index);
    });
  };

  return (
    <div className="w-full font-Outfit">
      <p className="text-black text-xl py-2 font-bold">
        Educational Background
      </p>

      <div className="mb-20">
        {educationItems.map((item, index) => {
          const rowErrors = errors[index] || {};

          return (
            <div
              key={`education-${index}`}
              className="mb-6 rounded-xl border border-[#E5E7EB] p-4"
            >
              <div className="mb-3 flex items-center justify-between">
                <p className="text-sm font-semibold text-[#071C50]">
                  Education {index + 1}
                </p>
                {educationItems.length > 1 ? (
                  <button
                    type="button"
                    onClick={() => removeEducation(index)}
                    className="text-sm text-red-600"
                  >
                    Remove
                  </button>
                ) : null}
              </div>

              <div className="grid w-full text-[#000000] text-base grid-cols-1 md:grid-cols-3 gap-4">
                <FormField
                  id={`school-${index}`}
                  name="school"
                  label="Name of School"
                  required
                  value={item.school}
                  onChange={(event) => handleChange(index, event)}
                  placeholder="School"
                  error={showErrors ? rowErrors.school : ""}
                />

                <FormField
                  id={`degree-${index}`}
                  name="degree"
                  label="Degree"
                  required
                  as="select"
                  options={degreeOptions}
                  value={item.degree}
                  onChange={(event) => handleChange(index, event)}
                  error={showErrors ? rowErrors.degree : ""}
                />

                <FormField
                  id={`course-${index}`}
                  name="course"
                  label="Course"
                  required
                  value={item.course}
                  onChange={(event) => handleChange(index, event)}
                  placeholder="Course"
                  error={showErrors ? rowErrors.course : ""}
                />

                <FormField
                  id={`qualificationClass-${index}`}
                  name="qualificationClass"
                  label="Class of Degree"
                  required
                  value={item.qualificationClass}
                  onChange={(event) => handleChange(index, event)}
                  placeholder="e.g. First Class, Upper Credit"
                  error={showErrors ? rowErrors.qualificationClass : ""}
                />

                <FormField
                  id={`startYear-${index}`}
                  name="startYear"
                  label="Start Year"
                  required
                  value={item.startYear}
                  onChange={(event) => handleChange(index, event)}
                  placeholder="YYYY"
                  type="number"
                  error={showErrors ? rowErrors.startYear : ""}
                />

                <FormField
                  id={`endYear-${index}`}
                  name="endYear"
                  label="End Year"
                  required
                  value={item.endYear}
                  onChange={(event) => handleChange(index, event)}
                  placeholder="YYYY"
                  type="number"
                  error={showErrors ? rowErrors.endYear : ""}
                />
              </div>
            </div>
          );
        })}

        <div className="py-6">
          <button
            type="button"
            onClick={addEducation}
            className="bg-black rounded-2xl w-40 text-white py-2"
          >
            + Add new
          </button>
        </div>
      </div>
    </div>
  );
};

export default Education;
